import React, { useEffect, useRef } from "react";
import "./Resume.css";

const skillData = [
  { label: "HTML5 & CSS3", width: 96 },
  { label: "Sass & Less", width: 85 },
  { label: "Bootstrap", width: 88 },
  { label: "JavaScript", width: 90 },
  { label: "AutoCAD Civil Arch", width: 92 },
  { label: "Google SketchUp", width: 85 },
  { label: "Lumion", width: 80 },
  { label: "Revit Architecture", width: 78 },
  { label: "Technical Drawing", width: 90 },
  { label: "Problem-Solving", width: 88 },
  { label: "Drafting", width: 93 },
  { label: "Attention to Detail", width: 95 },
];

const services = [
  {
    title: "Project Management",
    details: [
      "Project Management / Supervision Services",
      "Project Planning",
      "Project Execution",
      "Project Closure",
      "Site Supervision",
      "Resource Management",
      "Progress Monitoring",
      "Reporting and Documentation",
      "Safety Management",
    ],
  },
  {
    title: "2D and 3D Floor Planning",
    details: [
      "2D floor plan",
      "Furniture layout",
      "Space planning",
      "Site working plan",
      "Site layout",
    ],
  },
  {
    title: "Structural Drawing",
    details: [
      "Foundation Plans",
      "Column Detail Plans",
      "Roof Plans",
      "Detail Drawings",
      "Section Drawings",
      "Elevation Drawings",
    ],
  },
  {
    title: "3D Elevation Drawing",
    details: [
      "3D Exterior Design and Visualization",
      "Experience the building's exterior before construction",
      "Exterior visualization aids in selecting colors and textures",
      "Enhance aesthetics with architectural features, parametric elements, and pergolas",
    ],
  },
  {
    title: "Interior Designs",
    details: [
      "Modular Kitchen",
      "Bedroom Interior",
      "Living Room Interior",
      "Bathroom Interior",
      "Dining Room Interior",
      "Commercial Interior",
      "Showroom Interiors",
      "Balcony Designing",
      "Traditional Interior Designing",
      "Modern Interior Designing",
      "Etc.",
    ],
  },
  {
    title: "MEP Drawings",
    details: [
      "Mechanical Drawings",
      "HVAC (Heating, Ventilation, and Air Conditioning)",
      "Electrical Drawings",
      "Control panel",
      "Power distribution channel",
      "Exterior and interior lighting",
      "Plumbing Drawings",
      "Garbage, Drainage, Waste carriers, Piping systems",
    ],
  },
];

const Resume = () => {
  const skillRefs = useRef([]);

  useEffect(() => {
    skillRefs.current.forEach((ref, i) => {
      if (ref) {
        ref.style.width = "0%";
        setTimeout(() => {
          ref.style.transition = "width 1.2s cubic-bezier(.4,0,.2,1)";
          ref.style.width = skillData[i].width + "%";
        }, 200 + i * 120);
      }
    });
  }, []);

  return (
    <div className="resume-container">
      <div className="resume-header">
        <h1>Johnson Blessed Cole</h1>
        <h2>CEO, JBC-DESIGN-STUDIO</h2>
        <p className="subtitle">
          Architectural Draftsman & Frontend Developer
        </p>
      </div>

      {/* <div className="resume-section about">
        <h3>About Me</h3>
        <p>
          I am an Architectural Draftsman and Frontend Developer with a strong background in architectural drafting. I love creating digital experiences that combine creativity and technical skills. My goal is to improve my skills while helping others. Being self-employed has made me more independent and proactive in creating opportunities.
        </p>
      </div> */}





      <div className="resume-section skills">
        <h3>Technical Skills</h3>
        <div className="skills-list">
          {skillData.map((skill, i) => (
            <div className="skill-bar-row" key={skill.label}>
              <div className="skill-label">{skill.label}</div>
              <div className="skill-bar-bg">
                <div
                  className="skill-bar-fill"
                  ref={el => (skillRefs.current[i] = el)}
                  style={{ width: 0 }}
                >
                  {skill.width}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="resume-section services">
        <h3>My Services</h3>
        <div className="services-grid">
          <div className="service-card">Project Management</div>
          <div className="service-card">2D and 3D Floor Planning</div>
          <div className="service-card">Structural Drawing</div>
          <div className="service-card">3D Elevation Drawing</div>
          <div className="service-card">Interior Designs</div>
          <div className="service-card">MEP Drawings</div>
        </div>
      </div>

      <div className="resume-section education">
        <h3>Education</h3>
        <ul>
          <li>
            <strong>Naresh I Technologies Software Training Institute</strong> (2023)<br />
            Certification of Completion, UI Full Stack Web Development<br />
            Ameerpet, Hyderabad, Telangana, India
          </li>
          <li>
            <strong>CAD-DESK-INDIA</strong> (2022 - 2023)<br />
            Master Diploma in Architecture CAD<br />
            Ameerpet, Hyderabad, Telangana, India
          </li>
          <li>
            <strong>Monrovia Vocational Technical Training Center (M.V.T.C)</strong> (2018 - 2021)<br />
            Diploma in Architecture Drafting<br />
            Somalia Drive, Paynesville City, Monrovia, Liberia
          </li>
          <li>
            <strong>United Methodist High School George V. Gibson Memorial</strong> (2017)<br />
            High School Degree<br />
            Bassa Community, Kakata City, Margibi County, Liberia
          </li>
        </ul>
      </div> */}

      {/* <div className="resume-section languages">
        <h3>Languages</h3>
        <p>English</p>
      </div> */}
    </div>
  );
};

export default Resume;